// extracted by mini-css-extract-plugin
export default {"container":"eI-z","header":"fI-z","details":"gI-z","link":"hI-z"};